import {OpzioniItem} from "../gestversore/types";

export type DipProg = {
  id?: string;
  codprog?: string;
  coddip?: string;
  ditta?: number;
  molt?: number;
 };

export type DipProgApiResponse = {
  results: Array<DipProg>;
  count: number;
};


export function mapJsonToDipProgApiResponse(jsonData: any): DipProgApiResponse {
 const mappedData: DipProgApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.BT12_ID,
      codprog: item.BT12_CODPROG_VBT01,
      coddip: item.BT12_CODDIP,
      ditta: item.BT12_DITTA,
      molt: item.BT12_MOLT,
    }))
  };
  return mappedData;
};

export function mapDipProgToJson(datiProg: DipProg) {
  return {
    BT12_ID: datiProg.id,
    BT12_CODPROG_VBT01: datiProg.codprog,
    BT12_CODDIP: datiProg.coddip,
    BT12_DITTA: datiProg.ditta,
    BT12_MOLT: datiProg.molt,
  };
};

export function mapJsonToDipProg(jsonData: any): DipProg {
  return {
    id: jsonData.BT12_ID,
    codprog: jsonData.BT12_CODPROG_VBT01,
    coddip: jsonData.BT12_CODDIP,
    ditta: jsonData.BT12_DITTA,
    molt: jsonData.BT12_MOLT,
  };
}

export type DipProgDTO = {
  id?: string;
  coddip?: string;
  nomedip?: string;
  codprog?: string;
  desprog?: string;
  ditta?: number;
  molt?: number;
  ref?: string;
};

export type DipProgDTOApiResponse = {
  results: Array<DipProgDTO>;
  count: number;
};

export function mapJsonToDipProgDTOApiResponse(jsonData: any): DipProgDTOApiResponse {
 const mappedData: DipProgDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.VBT12_ID,
      coddip: item.VBT12_CODDIP,
      nomedip: item.VBT12_NOMEDIP,
      codprog: item.VBT12_CODPROG,
      desprog: item.VBT12_DESPROG,
      ditta: item.VBT12_DITTA,
      molt: item.VBT12_MOLT,
      ref: item.VBT12_REF,
    }))
  };
  return mappedData;
};
